<div>{{errorMsg}}</div>
<button class="btn btn-default" type="button" (click)="export()">Export</button>
<dx-data-grid id="gridContainer"
              [dataSource]="psresults"
              [remoteOperations] = "remoteOps"
              (onInitialized)="onInitialized($event)"
              [showBorders]="true"
              keyExpr="docID"
              (onCellClick)="imgClicked($event)"
              [allowColumnResizing]="true"
              [columnMinWidth]="150">

  <!--Don't open image in another tab'-->
  <!--<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage"></dxo-state-storing>-->
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-selection mode="single"></dxo-selection>
  <!--<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage" [savingTimeout]="500"></dxo-state-storing>-->
  <dxo-scrolling mode="virtual" columnRenderingMode="virtual"></dxo-scrolling>
  <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="false"></dxo-grouping>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-filter-row [visible]="showFilterRow"
                  [applyFilter]="currentFilter"></dxo-filter-row>
  <dxo-paging [enabled]="false"></dxo-paging>

  <dxi-column dataField="dept"
              caption="Department"
              >
  </dxi-column>
  <dxi-column dataField="unparsedName"
              caption="Business/LastName">
  </dxi-column>
  <dxi-column dataField="role"
              caption="Role">
  </dxi-column>
  <dxi-column dataField="recordDate"
              dataType="date"
              format="MM/dd/yyyy"
              caption="Date">
  </dxi-column>
  <dxi-column dataField="address">
  </dxi-column>
  <dxi-column dataField="cityTown"
              caption="City/Town">
  </dxi-column>
  <dxi-column dataField="docType"
              caption="Type">
  </dxi-column>
  <dxi-column dataField="amount"
              caption="Amount">
  </dxi-column>
  <dxi-column dataField="role2"
              caption="role2">
  </dxi-column>
  <dxi-column dataField="recLandBP"
              caption="Document">
  </dxi-column>
  <dxi-column dataField="description"
              caption="Desc">
  </dxi-column>
  <dxi-column [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              [width]="50">
  </dxi-column>
  <div *dxTemplate="let row of 'cellTemplate'">
    <div *ngIf=" row.data.recLandBook ; else showRegDoc">
      <a target="_blank" [routerLink]='["/property-search-doc-disp-pg", row.data.docID, row.data.recLandBook, row.data.recLandPage]' class="image">
        <img src="images/document-icon-blue.png" />
      </a>
    </div>
    <ng-template #showRegDoc>
      <a target="_blank" [routerLink]='["/property-search-doc-disp-pg", row.data.docID, row.data.recLandBP]' class="image">
        <img src="images/document-icon-blue.png" />
      </a>
    </ng-template>
  </div>
</dx-data-grid>
